<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Chargeback</h3>
        </div>

        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
            <button
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Informações"
              @click="Info()"
            >
              <i class="fas fa-info"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Percentual de chargebacks</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6
                    v-if="pagination.TotalItems > 0"
                    class="m-0"
                  >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Id</th>
                    <th scope="col" class="border-0">Id Marketplace</th>
                    <th scope="col" class="border-0">Confiável</th>
                    <th scope="col" class="border-0">Nome</th>
                    <th scope="col" class="border-0">Fraude/Geradas</th>
                    <th scope="col" class="border-0">Percentual</th>
                    <th scope="col" class="border-0">Risco</th>
                    <th scope="col" class="border-0">Recomendação</th>
                    <th scope="col" class="border-0">Bloqueado</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(chargeback, index) in listChargebacks" :key="index">
                    <td></td>
                    <td class="text-left">{{chargeback.IdMerchant}}</td>

                    <td v-if="chargeback.IdMerchantRoot > 0">{{chargeback.IdMerchantRoot}}</td>
                    <td v-if="chargeback.IdMerchantRoot == 0"></td>
                    <td>
                      <i :class="[GetTrustClass(chargeback.IsTrustable)]"></i>
                    </td>
                    <td>{{chargeback.Name}}</td>
                    <td class="td-with-subs">
                      <div>{{chargeback.QtAmountFraud}}</div>
                      <span class="td-span-style">{{chargeback.QtAmountBilled}}</span>
                    </td>
                    <td>{{chargeback.PercentageFraudAmount | percentage}}</td>
                    <td>
                      <i :class="[GetRiskClass(chargeback.Risk)]"></i>
                    </td>
                    <td>{{chargeback.Recommendation}}</td>
                    <td>
                      <i :class="[GetBlockedClass(chargeback.IsBlocked)]"></i>
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-if="listChargebacks == undefined || listChargebacks == null || listChargebacks.length == 0"
                  >
                    <td colspan="20">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mInfo"
      title="Informações"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <table class="table mb-0" v-if="!loadingList">
        <thead class="bg-s2p-gray-light">
          <tr>
            <th scope="col" class="border-0"></th>
            <th scope="col" class="border-0 text-left">Descrição</th>
            <th scope="col" class="border-0">Percentual</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <i class="fas fa-arrow-down fa-secondary"></i>
            </td>
            <td>Baixo</td>
            <td>Até 0,75%</td>
          </tr>
          <tr>
            <td>
              <i class="fas fa-check fa-success"></i>
            </td>
            <td>Normal</td>
            <td>Entre 0,75% e 2,00%</td>
          </tr>
          <tr>
            <td>
              <i class="fas fa-exclamation-triangle fa-warning"></i>
            </td>
            <td>Alto</td>
            <td>Entre 2,01% e 15,00%</td>
          </tr>
          <tr>
            <td>
              <i class="fas fa-skull-crossbones fa-danger"></i>
            </td>
            <td>Crítico</td>
            <td>Superior à 15,00%</td>
          </tr>
        </tbody>
      </table>

      <template slot="modal-footer">
        <b-button-group>
          <b-button size="sm" class="btn btn-secondary" hidden>
            <i class="fas fa-arrow-left"></i>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <date-field v-model="filter.ReferenceDate" format="MMMM yyyy" minimumView="month"></date-field>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsBuyDate" :value="null">
            <option :value="false">Por data de chargeback</option>
            <option :value="true">Por data de pagamento</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import dateField from "../common/date-field";
export default {
  name: "merchant-chargeback",
  components: {
    dateField,
  },
  data: function () {
    return {
      countFilter: 0,
      filter: {
        ReferenceDate: this.$options.filters.addMonth(new Date(), -1),
        IsBuyDate: false,
      },
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      listChargebacks: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantchargeback();
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantchargeback();
    },
  },
  mounted() {
    this.ListMerchantchargeback();
  },
  methods: {
    GetBlockedClass: function (isBlocked) {
      return isBlocked ? "fas fa-ban fa-danger" : "fas fa-minus";
    },
    GetTrustClass: function (IsTrustable) {
      return IsTrustable
        ? "far fa-check-circle fa-success"
        : "far fa-times-circle fa-danger";
    },
    GetRiskClass: function (risk) {
      switch (risk) {
        case "CRITICAL":
          return "fas fa-skull-crossbones fa-danger";
        case "HIGH":
          return "fas fa-exclamation-triangle fa-warning";
        case "NORMAL":
          return "fas fa-check fa-success";
        case "LOW":
          return "fas fa-arrow-down fa-secondary";
      }
      return isBlocked ? "fas fa-ban fa-red" : "fas fa-minus";
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantchargeback();
    },
    ListMerchantchargeback: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.ReferenceDate)) this.countFilter++;
      if (hasValue(this.filter.IsBuyDate)) this.countFilter++;

      let data = {
        ...this.pagination,
        ...{
          "Object.ReferenceDate": this.filter.ReferenceDate,
          "Object.IsBuyDate": this.filter.IsBuyDate,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListChargeback", { params: data })
        .then((response) => {
          this.listChargebacks = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os chargebacks",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Info: function () {
      this.$bvModal.show("mInfo");
    },
    ResetFilter: function () {
      this.filter = {
        ReferenceDate: this.$options.filters.addMonth(new Date(), -1),
        IsBuyDate: false,
      };
      this.ListMerchantchargeback();
    },
  },
};
</script>

<style scoped>
.fa-danger {
  color: #ff0000;
}

.fa-warning {
  color: #e6a200;
}

.fa-secondary {
  color: #00a2bf;
}

.fa-success {
  color: #09ab6f;
}
</style>

<style scoped>
.td-span-style {
  font-size: 10pt;
  opacity: 0.75;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/chargeback.vue